<lib-bottom-sheet [open]="isConsentModalOpen$$()" cssClass="consent-modal-sheet" [settings]="bottomSheetSettings" [showCloseButton]="false" contentBackground="var(--0-5-Cards)" [recalculate]="userConsents$$()" data-testid="consent-modal">
  <div class="consent-modal">
    <div class="header">
      <h2 class="title">{{ 'menu.consentModal.title' | transloco }}</h2>
      <p class="subtitle">{{ 'menu.consentModal.subtitle' | transloco }}</p>
    </div>

    @if (hasUncheckedOptionalConsents$$() && consentModalMode$$() === 'update') {
      <div class="info-note">
        <ion-icon name="alert-information-icon" class="info-icon"></ion-icon>
        <p class="info-text">{{ 'menu.consentModal.infoNote' | transloco }}</p>
      </div>
    }

    <div class="consent-items">
      @if (isUserConsentsLoading$$()) {
        @for (i of [1, 2, 3]; track i) {
          <div class="consent-item is-skeleton">
            <ion-skeleton-text [animated]="true" class="item-skeleton"></ion-skeleton-text>
            <ion-skeleton-text [animated]="true" class="checkbox-skeleton"></ion-skeleton-text>
          </div>
        }
      } @else {
        @for (item of userConsents$$(); track item.id) {
          <div class="consent-item" (click)="handleToggle(item.id)">
            <span class="item-label">
              <a class="item-link" (click)="$event.stopPropagation(); $event.preventDefault(); handleViewDocument(item.id, item.documentUrl)" [attr.data-testid]="'consent-' + item.id + '-document-link'">{{ item.name }}</a>
              @if (!item.optional) {
                <span class="mandatory-marker">*</span>
              }
            </span>
            <ion-checkbox [checked]="item.consented" (ionChange)="handleToggle(item.id)" (click)="$event.stopPropagation()" [attr.data-testid]="'consent-' + item.id + '-checkbox'"></ion-checkbox>
          </div>
        }
      }
    </div>

    <div class="actions">
      <lib-app-button expand="block" [disabled]="!isMandatoryConsentComplete$$()" [loading]="isConsentUpdateSubmitting$$()" (click)="handleSubmit()" data-testid="consent-update-button">{{
        (consentModalMode$$() === 'onboarding' ? 'menu.consentModal.actions.consentAndContinue' : 'menu.consentModal.actions.updateConsent') | transloco
      }}</lib-app-button>
      @if (consentModalMode$$() === 'update') {
        <lib-app-button expand="block" fill="clear" (click)="handleClose()" data-testid="consent-cancel-button">
          {{ 'menu.consentModal.actions.cancel' | transloco }}
        </lib-app-button>
      }
      @if (consentModalMode$$() === 'onboarding') {
        <lib-app-button expand="block" fill="clear" (click)="handleLogout()" data-testid="consent-logout-button">
          {{ 'menu.consentModal.actions.cancel' | transloco }}
        </lib-app-button>
      }
    </div>
  </div>
</lib-bottom-sheet>
